import { ChangeEvent, FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Tab, Tabs } from '@material-ui/core';

import { useStylesSecond } from './styles';
import TabPanel from 'components/TabPanel';
// import { useStore } from 'hooks/useRootStore';
import { UserEditRequestTable } from './UserEditRequestTable';
import { Badge } from '@mui/material';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useLocation, useHistory } from 'react-router-dom';

export const TabsEditRequest: FC = observer(() => {
  const classes = useStylesSecond();
  const history = useHistory();
  const location = useLocation();
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }
  const [profileRequestCount, setprofileRequestCount] = useState(0);
  const [registerRequestCount, setregisterRequestCount] = useState(0);
  const {
    userEditRequestTableStore: { NotificationCounter },
    notificationStore: { openNotification },
    userStore: { user },
  } = useStore();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  useQuery('NotificationCounterReq', () => NotificationCounter(), {
    onSuccess: (res: any) => {
      if (res?.data?.data) {
        setprofileRequestCount(res.data.data.profileRequestCount || 0);
        setregisterRequestCount(res.data.data.registerRequestCount || 0);
      }
    },
    onError: (e: any) => {
      openNotification('error', e);
    },
  });

  useEffect(() => {
    document.title = 'EasyIdentity: Reports: Admin Users';
  }, []);

  const getTabFromQuery = () => {
    const params = new URLSearchParams(location.search);
    if (user?.permission === 'Manager') {
      return 'one';
    }
    // For non-Manager users, default to 'one' if no tab specified
    return params.get('tab') || 'one';
  };

  const [value, setValue] = useState<string>(getTabFromQuery());

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
    history.push(`${location.pathname}?tab=${newValue}`);
  };
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <Tabs
          value={value}
          className={classes.tabs}
          TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
          onChange={handleChange}
        >
          {user?.permission !== 'Manager'
            ? [
                <Tab
                  key='one'
                  value='one'
                  wrapped
                  label={
                    <Badge badgeContent={registerRequestCount} color='error'>
                      <span>New User Requests</span>
                    </Badge>
                  }
                  {...a11yProps('one')}
                  className={classes.label}
                />,
                <Tab
                  key='two'
                  value='two'
                  wrapped
                  label={
                    <Badge badgeContent={profileRequestCount} color='error'>
                      <span>All User Requests</span>
                    </Badge>
                  }
                  {...a11yProps('two')}
                  className={classes.label}
                />,
              ]
            : [
                <Tab
                  key='one'
                  value='one'
                  wrapped
                  label={
                    <Badge badgeContent={profileRequestCount} color='error'>
                      <span>All User Requests</span>
                    </Badge>
                  }
                  {...a11yProps('one')}
                  className={classes.label}
                />,
              ]}
        </Tabs>

        {/* <Tabs value={value} onChange={handleChange}>
          <Tab value="one" label="New User Requests" />
          <Tab value="two" label="All User Requests" />
        </Tabs> */}
        <div className={classes.tabBox}>
          {user?.permission !== 'Manager' ? (
            [
              <TabPanel key='one' value={value} index='one'>
                <UserEditRequestTable newRequest />
              </TabPanel>,
              <TabPanel key='two' value={value} index='two'>
                <UserEditRequestTable />
              </TabPanel>,
            ]
          ) : (
            <TabPanel value={value} index='one'>
              <UserEditRequestTable />
            </TabPanel>
          )}
        </div>
      </Paper>
    </Grid>
  );
});
